
'use strict';

const scrollMargin = 15;




/*
 * Returns calculated height of header or 0
 */
function getHeaderHeight () {
    const mainHeader = document.querySelector('.main-header');
    const headerHeight = mainHeader.getBoundingClientRect() ?
                            mainHeader.getBoundingClientRect().height :
                            0;

    return headerHeight;
}

/*
 * Scrolls page to element
 */
export function scrollToElement (target, smooth = true) {
    const headerHeight = getHeaderHeight();

    const topPosition = target.getBoundingClientRect().top +
                        document.documentElement.scrollTop -
                        headerHeight -
                        scrollMargin;

    window.scrollTo({
        top: topPosition,
        behavior: smooth ? 'smooth' : 'instant'
    });
}





/*
 * Smooth scroll to anchor links
 */
export function setupAnchorScroll () {
    const anchorLinks = document.querySelectorAll('[href^="#"]');

    [...anchorLinks].forEach(link => {
        const anchor = link.getAttribute('href');
        if ( anchor !== '#' ) {
            const anchorTarget = document.querySelector(anchor);

            if ( anchorTarget !== null ) {
                link.addEventListener('click', evt => {
                    evt.preventDefault();

                    scrollToElement(anchorTarget);
                });
            }
        }
    });
}





/*
 * Dislace anchor links for header height
 */
export function scrollToAnchor () {
    const anchor = window.location.hash;

    if ( anchor ) {
        const target = document.querySelector(anchor);
        const headerHeight = getHeaderHeight() + scrollMargin;

        if ( target ) {
            target.style.paddingTop = `${headerHeight}px`;
            target.style.marginTop = `-${headerHeight}px`;

            const targetTop = target.getBoundingClientRect().top + document.documentElement.scrollTop;

            window.scrollTo({
                top: targetTop,
                behavior: 'instant'
            });
        }
    }
}
